import React from "react";
import { CreditCard } from "@mui/icons-material";
import { Box, Typography, Button } from "@mui/material";
import { usePayment, useTheme } from "../hooks";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getContrastTextColor } from "../utils/colorManager";
interface MerchantInfoProps {
  borderColor: string;
  merchantName: string;
  logoSrc?: string;
}

const MerchantInfo: React.FC<MerchantInfoProps> = ({
  borderColor,
  merchantName,
  logoSrc,
}) => {
  const { currentStep } = usePayment();
  const { theme } = useTheme();
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        bgcolor: "white",
        border: 1,
        borderColor: borderColor,
        borderBottom: "none",
        borderRadius: 1,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        p: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        {logoSrc ? (
          <img
            src={logoSrc}
            alt={merchantName}
            style={{ width: 62, marginRight: 15 }}
          />
        ) : (
          <CreditCard sx={{ width: 62, height: 24, color: "#d97706", mr: 5 }} />
        )}
        <Typography
          variant="h6"
          fontWeight="bold"
          color={getContrastTextColor("white")}
        >
          {merchantName}
        </Typography>
      </Box>
      {currentStep === 1 && (
        <Button
          variant="contained"
          onClick={() => navigate(`/${theme?.url}`)}
          sx={{
            bgcolor: theme.color_primary,
            "&:hover": {
              bgcolor: "amber.200",
            },
          }}
        >
          <Typography color={getContrastTextColor(theme.color_primary)}>
            {t("payment.change_service")}
          </Typography>{" "}
        </Button>
      )}
    </Box>
  );
};

export default MerchantInfo;
